import {
  BalanceId,
  Contractor,
  getBalanceIdQueryParam,
  getContractorQueryParam,
  getTokenQueryParam,
} from "@bb/game-products-ui";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { State } from "./types";

const balanceId = getBalanceIdQueryParam();
const contractor = getContractorQueryParam();
const token = getTokenQueryParam();

const STATE: State = {
  balanceId,
  contractor,
  token,
};

export const userSlice = createSlice({
  name: "user",
  initialState: STATE,
  reducers: {
    balanceIdUpdated: (state, action: PayloadAction<BalanceId>) => {
      state.balanceId = action.payload;
    },
    contractorUpdated: (state, action: PayloadAction<Contractor>) => {
      state.contractor = action.payload;
    },
    tokenUpdated: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
  },
});

export const userActions = {
  ...userSlice.actions,
};
